'use strict';

module.exports = [require('./and'), require('./not'), require('./or'), require('./xor')];


//////////////////
// WEBPACK FOOTER
// ./node_modules/mathjs/lib/function/logical/index.js
// module id = gJep
// module chunks = 0